export default "__VITE_ASSET__C9D847$y__"